export const Marquee = ({ items, testId = "editorial-marquee" }) => (
  <div className="overflow-hidden border-y border-forest/10 bg-white py-5" data-testid={testId}>
    <div className="flex w-max animate-marquee">
      {[0, 1].map((n) => (
        <div key={n} aria-hidden={n === 1} className="flex shrink-0 items-center">
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="px-8 font-mono text-xs tracking-[0.28em] uppercase text-forest/70 whitespace-nowrap">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-amber shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
